import type { RouteObject } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import Home from "@/pages/home/page";
import News from "@/pages/news/page";
import Works from "@/pages/works/page";
import Detail from "@/pages/detail/page";
import Profile from "@/pages/profile/page";
import Contact from "@/pages/contact/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "news", element: <News /> },
      { path: "works", element: <Works /> },
      { path: "works/:category", element: <Works /> },
      { path: "detail/:id", element: <Detail /> },
      { path: "profile", element: <Profile /> },
      { path: "contact", element: <Contact /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;